<template>
  <div v-if="currentAbsence">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 mt-1">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="fa fa-info-circle text-custom-primary"></i>
                        <span class="font-weight-bold"> Employé absent</span>
                      </span>
                      <span
                        ><a
                          style="cursor: pointer"
                          title="Aperçu employé"
                          @click="viewEmploye(currentAbsence.employe_id)"
                          >{{ currentAbsence.employe }}
                          <i class="fa fa-eye ml-2"></i></a
                      ></span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="fa fa-info-circle text-custom-primary"></i>
                        <span class="font-weight-bold">Type Absence</span>
                      </span>
                      <span>
                        {{ currentAbsence.type_absence }}
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="far fa-calendar text-custom-primary"></i>
                        <span class="font-weight-bold"> Remplaçant</span>
                      </span>
                      <span>
                        <a
                          v-if="currentAbsence.remplacant_id"
                          style="cursor: pointer"
                          title="Aperçu employé"
                          @click="viewEmploye(currentAbsence.remplacant_id)"
                          >{{ currentAbsence.remplacant }}
                          <i class="fa fa-eye ml-2"></i
                        ></a>
                        <span v-else>{{ currentAbsence.remplacant }}</span>
                      </span>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" class="pt-4">
                    <span>
                      <i class="mdi mdi-comment-edit text-custom-primary"></i>
                      <span class="font-weight-bold"> Commentaire</span>
                    </span>
                    <div class="p-3">{{ currentAbsence.commentaire }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end bg-white p-3">
        <div>
          <span class="mr-2"
            ><i class="far fa-user text-custom-primary"></i>
            <span class="font-weight-bold"> Auteur</span></span
          >
          <span> {{ currentAbsence.auteur }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { VueEditor } from 'vue2-editor';
export default {
  props: {
    currentAbsence: {
      type: Object,
      required: true,
    },
  },
  components: {
    // VueEditor,
  },
  methods: {
    viewEmploye(id) {
      return this.$router.push({
        name: 'rh_employe-show',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
